export const SourceReleaseType = "releasetypes";

export const TitleReleaseType = { list: "Release Type List", edit: "Edit Release Type", create: "Create Release Type" };
